import React from "react";
import SocialLinks from "./SocialLinks";

const Banner = () => (
  <div className="row banner">
    <div className="banner-text">
      <h1 className="responsive-headline">I'm Jon Chin.</h1>
      <h3>
	  I'm an <strong>educator</strong>, <strong>poet</strong>, <strong>2nd dan blackbelt</strong>, <strong>software engineer</strong>, and <strong>social entrepreneur</strong>.
      </h3>
      <hr />
      <SocialLinks />
    </div>
  </div>
);

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js